import { render, staticRenderFns } from "./boxList.vue?vue&type=template&id=6c195b55&scoped=true"
import script from "./boxList.vue?vue&type=script&lang=js"
export * from "./boxList.vue?vue&type=script&lang=js"
import style0 from "./boxList.vue?vue&type=style&index=0&id=6c195b55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c195b55",
  null
  
)

export default component.exports